import { render, staticRenderFns } from "./ComponentUserMessage.vue?vue&type=template&id=36c443fd&scoped=true"
import script from "./ComponentUserMessage.vue?vue&type=script&lang=js"
export * from "./ComponentUserMessage.vue?vue&type=script&lang=js"
import style0 from "./ComponentUserMessage.vue?vue&type=style&index=0&id=36c443fd&prod&lang=scss&scoped=true"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c443fd",
  null
  
)

export default component.exports